export default __webpack_public_path__ + "static/media/2.fdc272a8.svg";